<template>
  <Grid
    class="plants-grid"
    :data-items="facilities"
    :columns="columns"
    :loader="loading"
    data-cy="plants-grid"
  >
    <template v-slot:NameStatusCell="{ props: { dataItem } }">
      <td class="k-table-td">
        <span class="plants-grid__name-status"
          >{{ dataItem.Name }} <br />
          {{ dataItem.StatusDisplayName }}</span
        >
      </td>
    </template>
    <template v-slot:AddressCell="{ props: { dataItem } }">
      <td class="k-table-td">
        <span>{{ getAddress(dataItem) }}</span>
      </td>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { Grid } from "@progress/kendo-vue-grid";
import { ref } from "vue";
import type { GridColumnPropsExtended } from "@/Domain/GridColumnPropsExtended";
import type { Facility } from "@/Domain/Facility";

defineProps<{
  facilities: Facility[];
  loading?: boolean;
}>();

const columns = ref<GridColumnPropsExtended[]>([
  {
    title: "Name & Status",
    field: "Name",
    cell: "NameStatusCell",
  },
  {
    title: "Address",
    field: "Street1",
    cell: "AddressCell",
  },
  {
    title: "Visiting Rabbi",
    field: "DesignatedRfrName",
  },
]);

const getAddress = (facility: Facility) => {
  return `${facility.Street1} ${facility.Street2} ${facility.Street3} ${facility.City}, ${facility.State} ${facility.Country} ${facility.Zip}`;
};
</script>

<style scoped lang="scss">
.plants-grid {
  min-height: 100px;
  max-height: 350px;

  .plants-grid__name-status {
    color: #337ab7;
  }
}
</style>
